import React from 'react';
import styles from './UIGamePlayerInfoHeaderPointsPrivate.module.scss';
import { getColorFromPlayerColor } from '../../../UIGamePlayerInfoContainer/UIGamePlayerInfoContainerUtils.ts';
export const UIGamePlayerInfoHeaderPointsPrivate = ({ points, playerColor })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        style: {
            '--color': getColorFromPlayerColor(playerColor)
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.points
    }, points));
